
import { useState } from 'react';
import Logo from '../../../components/base/Logo';

export default function ContentMarketing() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    website: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <Logo />
            <nav className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Главная</a>
              <a href="/blog" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Блог</a>
              <a href="#services" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Услуги</a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Контакты</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-green-50 to-emerald-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Контент-маркетинг для SEO
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Создаем качественный контент, который привлекает целевую аудиторию и улучшает позиции в поисковых системах
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
                  Заказать контент
                </button>
                <button className="border border-green-600 text-green-600 px-8 py-3 rounded-lg font-semibold hover:bg-green-50 transition-colors whitespace-nowrap cursor-pointer">
                  Примеры работ
                </button>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Content%20marketing%20strategy%20workspace%20with%20laptop%20showing%20blog%20articles%2C%20SEO%20content%20creation%2C%20keyword%20research%20tools%2C%20and%20content%20calendar%20planning%20with%20modern%20clean%20design%20and%20bright%20background&width=600&height=400&seq=content-hero&orientation=landscape"
                alt="Контент-маркетинг"
                className="rounded-lg shadow-xl object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Почему контент важен для SEO
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Качественный контент - основа успешного продвижения в поисковых системах
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-search-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Органический трафик</h3>
              <p className="text-gray-600">
                Качественные статьи привлекают посетителей из поисковых систем по целевым запросам
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-user-heart-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Доверие аудитории</h3>
              <p className="text-gray-600">
                Экспертный контент повышает доверие к бренду и увеличивает лояльность клиентов
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-link-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Естественные ссылки</h3>
              <p className="text-gray-600">
                Полезный контент получает естественные ссылки от других сайтов
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-time-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Долгосрочный эффект</h3>
              <p className="text-gray-600">
                Качественные статьи работают годами, постоянно привлекая новых посетителей
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-trophy-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Экспертность</h3>
              <p className="text-gray-600">
                Демонстрируем экспертность в вашей нише, что важно для алгоритмов Google
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-share-line text-2xl text-indigo-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Социальные сигналы</h3>
              <p className="text-gray-600">
                Интересный контент активно делится в социальных сетях
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Виды контента, которые мы создаем
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Разнообразные форматы контента для максимального охвата аудитории
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-sm">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-article-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">SEO-статьи</h3>
              <p className="text-gray-600 mb-4">
                Информационные статьи, оптимизированные под ключевые запросы
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Глубокий анализ темы</li>
                <li>• Оптимизация под ключевые слова</li>
                <li>• Уникальность 100%</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-guide-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Гайды и инструкции</h3>
              <p className="text-gray-600 mb-4">
                Подробные руководства по решению проблем пользователей
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Пошаговые инструкции</li>
                <li>• Практические примеры</li>
                <li>• Визуальное оформление</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-list-check-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Обзоры и сравнения</h3>
              <p className="text-gray-600 mb-4">
                Детальные обзоры продуктов и услуг в вашей нише
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Объективная оценка</li>
                <li>• Сравнительные таблицы</li>
                <li>• Рекомендации экспертов</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-question-answer-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">FAQ и ответы</h3>
              <p className="text-gray-600 mb-4">
                Ответы на частые вопросы клиентов в формате статей
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Популярные вопросы</li>
                <li>• Подробные ответы</li>
                <li>• Структурированная разметка</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-news-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Новости отрасли</h3>
              <p className="text-gray-600 mb-4">
                Актуальные новости и тренды в вашей сфере деятельности
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Свежие новости</li>
                <li>• Экспертные комментарии</li>
                <li>• Прогнозы развития</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-presentation-line text-2xl text-indigo-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Кейсы и истории</h3>
              <p className="text-gray-600 mb-4">
                Реальные истории успеха и практические кейсы
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Реальные результаты</li>
                <li>• Детальный анализ</li>
                <li>• Выводы и рекомендации</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Как мы создаем контент
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Системный подход к созданию качественного SEO-контента
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-white">1</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Анализ ниши</h3>
              <p className="text-gray-600">
                Изучаем вашу отрасль, конкурентов и целевую аудиторию
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-white">2</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Подбор ключевых слов</h3>
              <p className="text-gray-600">
                Находим релевантные запросы с оптимальной конкуренцией
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-white">3</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Создание контента</h3>
              <p className="text-gray-600">
                Пишем экспертные статьи с учетом SEO-требований
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-white">4</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Оптимизация</h3>
              <p className="text-gray-600">
                Дорабатываем контент на основе аналитики и обратной связи
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Стоимость контент-маркетинга
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Гибкие тарифы в зависимости от объема и сложности контента
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white border border-gray-200 rounded-xl p-8">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Стартовый</h3>
                <div className="text-4xl font-bold text-gray-900 mb-2">20 000₽</div>
                <p className="text-gray-600">в месяц</p>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">4 SEO-статьи в месяц</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">До 3000 символов каждая</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">Подбор ключевых слов</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">Базовая оптимизация</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">Уникальность 100%</span>
                </li>
              </ul>
              <button className="w-full bg-gray-100 text-gray-900 py-3 rounded-lg font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer">
                Выбрать тариф
              </button>
            </div>

            <div className="bg-green-600 text-white rounded-xl p-8 relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-orange-500 text-white px-4 py-1 rounded-full text-sm font-semibold">
                  Популярный
                </span>
              </div>
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold mb-4">Профессиональный</h3>
                <div className="text-4xl font-bold mb-2">35 000₽</div>
                <p className="text-green-100">в месяц</p>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-300 mr-3"></i>
                  <span>8 SEO-статей в месяц</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-300 mr-3"></i>
                  <span>До 5000 символов каждая</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-300 mr-3"></i>
                  <span>Глубокий анализ ключевых слов</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-300 mr-3"></i>
                  <span>Полная SEO-оптимизация</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-300 mr-3"></i>
                  <span>Изображения и инфографика</span>
                </li>
              </ul>
              <button className="w-full bg-white text-green-600 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                Выбрать тариф
              </button>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-8">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Корпоративный</h3>
                <div className="text-4xl font-bold text-gray-900 mb-2">60 000₽</div>
                <p className="text-gray-600">в месяц</p>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">15 SEO-статей в месяц</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">До 7000 символов каждая</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">Экспертные интервью</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">Персональный редактор</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">Контент-стратегия</span>
                </li>
              </ul>
              <button className="w-full bg-gray-100 text-gray-900 py-3 rounded-lg font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer">
                Выбрать тариф
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Заказать контент-маркетинг
            </h2>
            <p className="text-xl text-gray-600">
              Расскажите о вашем проекте и мы подготовим индивидуальное предложение
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl shadow-lg p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Ваше имя *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="Введите ваше имя"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="your@email.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Телефон *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="+7 (999) 123-45-67"
                  />
                </div>
                <div>
                  <label htmlFor="website" className="block text-sm font-medium text-gray-700 mb-2">
                    Сайт
                  </label>
                  <input
                    type="url"
                    id="website"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="https://yoursite.com"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Описание проекта
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm resize-none"
                  placeholder="Расскажите о вашей нише, целевой аудитории и задачах..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Максимум 500 символов</p>
              </div>

              <button
                type="submit"
                className="w-full bg-green-600 text-white py-4 rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Заказать контент-маркетинг
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <Logo className="text-white mb-4" />
              <p className="text-gray-400">
                Профессиональное SEO продвижение сайтов с гарантией результата
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Услуги</h4>
              <ul className="space-y-2">
                <li><a href="/services/seo-audit" className="text-gray-400 hover:text-white transition-colors cursor-pointer">SEO Аудит</a></li>
                <li><a href="/services/technical-optimization" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Техническая оптимизация</a></li>
                <li><a href="/services/content-marketing" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Контент-маркетинг</a></li>
                <li><a href="/services/linkbuilding" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Линкбилдинг</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Компания</h4>
              <ul className="space-y-2">
                <li><a href="/blog" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Блог</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">О нас</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Кейсы</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Контакты</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Контакты</h4>
              <ul className="space-y-2 text-gray-400">
                <li>+7 (950) 360-35-20</li>
                <li>info@seo-agency.ru</li>
                <li>Москва, ул. Примерная, 123</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 SEO Agency. Все права защищены. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
